import { Box, Typography } from "@mui/material";
import { useOutlet, useParams } from "react-router-dom";

import CustomDataTable from "../../components/CustomDataTable/CustomDataTable";
import { ENDPOINT } from "../../services/endPoints";
import InformationBox from "../../components/InformativeBox/InformativeBox";
import React from "react";

export const conditionalRowStyles = [
  {
    when: row => row.form_viewed === "1",
    style: {
      backgroundColor: 'rgba(127, 255, 0, 0.6)',
    },
  },
  {
    when: row => row.form_viewed === "1" && row.form_accept_reject === "2",
    style: {
      backgroundColor: 'rgba(255, 0, 0, 0.6)',
    },
  },
];

const PatientReferredList = () => {
  let { hospital_id } = useParams();
 
  const excludedKeys = [
    "id",
    "updatedAt",
    "patient_DOB",
    "patient_middle_name",
    "dob",
    "phone_number",
    "zip_code",
    "deletedAt",
    "createdAt",
    "question1",
    "question2",
    "question3",
    "education_level",
    "occupation",
    "country_of_origin",
    "disability",
    "permanent_residential_address",
    "inkhundla",
    "chiefdom",
    "current_residential_address",
    "postal_address",
    "primary_cellphone",
    "secondary_cellphone",
    "land_phone",
    "patient_email_id",
    "patient_cmis_id",
    "patient_code",
    "nurses_id",
    "hospital_id",
    "hospital_Name",
    "hospital_region",
    "doctore_comments1",
    "form_filling_year",
    "form_code",
    "doctore_comments2",
    "doctore_comments3",
    "form_accept_reject",
    "form_viewed",
    "year",
    "pf_id",
    "nurses_region",
    "facility_type",
    "form_filling_Date",
  ];

  const customWidth = {
    patient_name: "150px",
    patient_age: "50px",
    patient_gender: "50px",
    patient_natinal_id: "250px",
    nurse_name: "150px",
    facility_name: "250px",
    form_type: "50px",

  };

  const compareValue = [
    "id",
    "patient_name",
    "patient_age",
    "patient_DOB",
    "patient_gender",
    "patient_natinal_id",
    "patient_cmis_id",
    "patient_code",
    "nurses_id",
    "facility_name",
    "facility_type",
    "hospital_id",
    "hospital_Name",
    "hospital_region",
    "form_accept_reject",
    "doctore_comments1",
    "form_viewed",
    "form_filling_Date",
    "form_filling_year",
    "form_code",
    "form_type",
    "form_risk_rating",
    "createdAt",
    "updatedAt",
    "deletedAt",
    "pf_id",
    "nurses_region",
    "facility_type",
    "form_filling_Date",
    "nurse_name"
  ];

  const customKeyName = {
    "patient_name": "Patient Name",
    "patient_age": "Age",
    "patient_DOB": "DOB",
    "patient_gender": "Sex",
    "patient_natinal_id": "National ID",
    "nurses_id": "Nurse ID",
    "nurse_name": "Nurse Name",
    "facility_name": "Facility Name",
    "hospital_id": "Hospital ID",
    "hospital_Name": "Reffered Facility Name",
    "form_accept_reject": "Accept/Reject",
    "form_viewed": "Form Viewed",
    "form_code": "Form Code",
    "form_type": "Form Type",
    "form_risk_rating": "Risk Rating",
};



  return (
      <>
          <CustomDataTable
                tableTitle={"Referred Patient List"}
                endPoint={`${ENDPOINT.PATIENT_REFERRED_LIST}/${hospital_id}`}
                hospital_id={hospital_id}
                filterKey={"patient_name"}
                excludedKeys={excludedKeys}
                compareValue={compareValue}
                customKeyName={customKeyName}
                customWidth={customWidth}
                conditionalRowStyles={conditionalRowStyles}
          />

          <InformationBox/>
      </>
    )
};

export default PatientReferredList;
